// extracted by mini-css-extract-plugin
export var bold = "styles-module__bold___Ks2Il";
export var card = "styles-module__card___kwNZh";
export var cardAndData = "styles-module__cardAndData___Eyxn0";
export var cardContainer = "styles-module__cardContainer___ptVVX";
export var cardMeta = "styles-module__cardMeta___OfQEl";
export var desktop = "styles-module__desktop___GHzBA";
export var giftCardCard = "styles-module__giftCardCard___deV8j";
export var giftCardPrint = "styles-module__giftCardPrint___y2A9c";
export var giftMessage = "styles-module__giftMessage___WcyX8";
export var inMobile = "styles-module__inMobile___L4eQP";
export var metadata = "styles-module__metadata___LxysQ";
export var planType = "styles-module__planType___WVmo_";
export var printButton = "styles-module__printButton___OqJYF";
export var printContainer = "styles-module__printContainer___JGmIQ";
export var redemptionCode = "styles-module__redemptionCode___tQXNt";
export var senderRecipient = "styles-module__senderRecipient___j3hUw";
export var subText = "styles-module__subText___XxUpJ";
export var subTextContainer = "styles-module__subTextContainer___UAphn";
export var yourGiftCard = "styles-module__yourGiftCard___vo0rm";